import React, { useEffect, useState } from 'react';
import JobCard from '../components/JobCard';
import AccessibilityBar from '../components/AccessibilityBar';
//import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';
import './PageStyles.css';

const DefenceJobs = () => {
  const [defenceJobs, setDefenceJobs] = useState([]);
  const [fallbackJobs, setFallbackJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/jobs?limit=1000`)
      .then(res => res.json())
      .then(data => {
        const allJobs = data.jobs || [];
        const filtered = allJobs.filter(job => job.jobType === 'Defence');

        if (filtered.length > 0) {
          setDefenceJobs(filtered);
        } else {
          setShowFallback(true);
          setFallbackJobs(allJobs);
        }

        setLoading(false);
      })
      .catch(() => {
        setDefenceJobs([]);
        setFallbackJobs([]);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <AccessibilityBar />
      <div className="container">
        <h1>🛡️ Defence Jobs</h1>

        {loading ? (
          <p>Loading jobs...</p>
        ) : showFallback ? (
          <>
            <p>No Defence jobs found. Showing all available jobs instead:</p>
            <div className="grid">
              {fallbackJobs.map(job => (
                <JobCard key={job._id} job={job} />
              ))}
            </div>
          </>
        ) : (
          <div className="grid">
            {defenceJobs.map(job => (
              <JobCard key={job._id} job={job} />
            ))}
          </div>
        )}
      </div>
      
    </>
  );
};

export default DefenceJobs;


/*import React, { useEffect, useState } from 'react';
import JobCard from '../components/JobCard';
import AccessibilityBar from '../components/AccessibilityBar';
//import Footer from '../components/Footer';
import { API_BASE_URL } from '../config/apiConfig';
import './PageStyles.css'; // Shared styling

const DefenceJobs = () => {
  // 🔄 State to hold filtered jobs
  const [defenceJobs, setDefenceJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  // 📡 Fetch jobs and filter by jobType
  useEffect(() => {
    fetch(`${API_BASE_URL}/api/jobs`)
      .then(res => res.json())
      .then(data => {
        const filtered = data.jobs?.filter(job => job.jobType === 'defence') || [];
        setDefenceJobs(filtered);
        setLoading(false);
      })
      .catch(() => {
        setDefenceJobs([]);
        setLoading(false);
      });
  }, []);

  return (
    <>
      <AccessibilityBar />
      <div className="container">
        <h1>🛡️ Defence Jobs</h1>

        {loading ? (
          <p>Loading Defence jobs...</p>
        ) : defenceJobs.length > 0 ? (
          <div className="grid">
            {defenceJobs.map(job => (
              <JobCard key={job._id} job={job} />
            ))}
          </div>
        ) : (
          <p>No Defence jobs available at the moment.</p>
        )}
      </div>
     
    </>
  );
};

export default DefenceJobs;
*/